<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/leaves"></top-nav-bar>

        <form class="max-w-sm mx-auto px-4 overflow-y-auto pb-16 md:pb-0 py-2" @submit.prevent="save">
            <h3 class="text-center mb-8">Registration</h3>

            <leave-form v-model="leave"
                        @resetPercentageDecimal="resetPercentageDecimal"
                        @activeFileUpload="activeFileUpload">
            </leave-form>

            <div class="block text-red text-center w-3/4 m-auto pb-4">
                <small>
                    <i class="far fa-exclamation-triangle"></i>
                    Once registered, it is not possible to change the details. Please review all details before proceeding.
                </small>
            </div>

            <div class="block md:inline-flex md:float-right">
                <button class="btn btn--colored__blue w-full"
                        :disabled="disabled"
                        :class="{'disabled': disabled}"
                        type="submit">
                    <i class="fal fa-spin fa-circle-notch" v-if="disabled"></i>
                    Register
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import LeaveForm from '@/partials/LeaveForm.vue';
    import ResetsPercentage from '../mixins/ResetsPercentage';
    import CanAccessView from '../mixins/CanAccessView';

    export default {
        mixins: [CanAccessView, ResetsPercentage],

        components: {
            LeaveForm
        },

        data() {
            return {
                leave: {
                    start: null,
                    end: null,
                    percentage: [],
                    subtype: {
                        id: null,
                    },
                    comment: null,
                    documents: []
                },
                disabled: false,
            }
        },

        methods: {
            activeFileUpload(value) {
                this.disabled = !value;
            },

            save() {
                if (this.disabled) {
                    return;
                }

                if (!this.leave.subtype.id) {
                    return this.$noty.error('Please select a type before submitting.');
                }

                let form = new FormData();

                Object.keys(this.leave).forEach(key => {
                    if (key === 'id') return;

                    if (key === 'documents') {
                        this.leave.documents.forEach((document, index) => {
                            if (document.hasOwnProperty('response')) {
                                form.append(`${key}[${index}]`, document.response.data.id);
                            }
                        });
                        return;
                    }

                    if (key === 'subtype') {
                        form.append('subtype_id', this.leave.subtype.id);
                        return;
                    }

                    if (Array.isArray(this.leave[key])) {
                        this.leave[key].forEach((value, index) => {
                            form.append(`${key}[${index}]`, value);
                        })
                    } else {
                        form.append(key, this.leave[key] || '');
                    }
                });

                this.disabled = true;

                this.$api('leave-tracker/pub').post('', form)
                    .then(() => {
                        this.disabled = false;
                        this.$router.replace('/leaves');
                    })
                    .catch(error => {
                        this.disabled = false;
                        this.leave.documents = this.leave.documents.map((document, index) => {
                            if (error.response.data.errors.hasOwnProperty('documents.' + index)) {
                                document.error = error.response.data.errors['documents.' + index][0];
                                document.success = false;
                            } else {
                                document.error = false;
                                document.success = true;
                            }

                            return document;
                        });
                    });
            }
        }
    }
</script>
